import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";
import { organizationTranslationChunksConfig, organizationTranslationsDe, organizationTranslationsEn } from "@spartacus/organization/administration/assets";
import { AdministrationRootModule } from "@spartacus/organization/administration/root";
import { nl as translationsNl } from '../../../../assets/i18n-assets/nl';

@NgModule({
  declarations: [],
  imports: [
    AdministrationRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      organizationAdministration: {
        module: () =>
          import('@spartacus/organization/administration').then((m) => m.AdministrationModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: {
          en: organizationTranslationsEn,
          de: organizationTranslationsDe,
          nl: translationsNl,
        },
      chunks: organizationTranslationChunksConfig,
    },
  })
  ]
})
export class OrganizationAdministrationFeatureModule { }
